import * as React from "react";
import { Modal } from "react-bootstrap";
import moment from "moment";

import { IEventTemplate } from "src/api/events";
import { IOrganization } from "src/api/organizations";

import DatePicker from "src/components/structure/DatePicker";
import { error } from "src/components/structure/Alert";
import { EventsAPI } from "src/api";

interface ICreateTime {
  startTime: string;
  numberOfMinutes: string;
}

interface IEventInstanceCreateModalProps {
  show: boolean;
  organization: IOrganization;
  templates: IEventTemplate[];
  hide: () => void;
  onInstancesCreated: () => void;
}

interface IEventInstanceCreateModalState {
  loading: boolean;
  selectedTemplateId: number;
  showAddStartTimeModal: boolean;
  showPreviewModal: boolean;
  loadingWhileCalculating: boolean;
  startDate: moment.Moment;
  startTime: string;
  numberOfMinutes: string;
  additionalStartTime: string;
  additionalNumberOfMinutes: string;
  repeatMultiplePerDay: "yes" | "no";
  additionalCreateTimes: ICreateTime[]; // these are the hours to repeat each day
  allCreateTimes: ICreateTime[]; // these are all of the instances to create, stored in the createTimes field of the POST
  releaseOnType: "immediately" | "absolute" | "relative";
  releaseOnDate: moment.Moment;
  releaseOnTime: string;

  // weekly repeat state
  repeatWeekly: "yes" | "no";
  repeatSunday: "yes" | "no";
  repeatMonday: "yes" | "no";
  repeatTuesday: "yes" | "no";
  repeatWednesday: "yes" | "no";
  repeatThursday: "yes" | "no";
  repeatFriday: "yes" | "no";
  repeatSaturday: "yes" | "no";
  repeatEndMethod: "endDate" | "numberOfDays";
  repeatEndDate: moment.Moment;
  repeatEndDays: number; 
}

const nextTime = moment().add(1, "hours").format("HH:00");
const nextAdditionalTime = moment().add(1, "hours").format("HH:15");

const initialState: IEventInstanceCreateModalState = {
  loading: false,
  selectedTemplateId: 0,
  loadingWhileCalculating: false,
  showAddStartTimeModal: false,
  showPreviewModal: false,
  startDate: moment(),
  startTime: nextTime,
  numberOfMinutes: "30",
  additionalStartTime: nextAdditionalTime,
  additionalNumberOfMinutes: "0",
  repeatMultiplePerDay: "no",
  additionalCreateTimes: [],
  allCreateTimes: [],
  // weekly repeat state
  repeatWeekly: "no",
  repeatSunday: "no",
  repeatMonday: "no",
  repeatTuesday: "no",
  repeatWednesday:  "no",
  repeatThursday: "no",
  repeatFriday: "no",
  repeatSaturday: "no",
  repeatEndMethod: "numberOfDays",
  repeatEndDate: moment().add(14, "days"),
  repeatEndDays: 14, 

  releaseOnType: "immediately",
  releaseOnDate: moment(),
  releaseOnTime: "12:00",
}

export default class EventInstanceCreateModal extends React.Component<IEventInstanceCreateModalProps, IEventInstanceCreateModalState> {

  constructor(props: any){
    super(props);
    this.state = {
      ...initialState,
    };

    this.toggleModal = this.toggleModal.bind(this);
    this.togglePreviewModal = this.togglePreviewModal.bind(this);
    this.updateField = this.updateField.bind(this);
    this.updateStartDate = this.updateStartDate.bind(this);
    this.updateEndDate = this.updateEndDate.bind(this);
    this.updateReleaseDate = this.updateReleaseDate.bind(this);
    this.updateCheckbox = this.updateCheckbox.bind(this);
    this.toggleShowAdditionalTimeModal = this.toggleShowAdditionalTimeModal.bind(this);
    this.addNewAdditionalTime = this.addNewAdditionalTime.bind(this);
    this.removeAdditionalTime = this.removeAdditionalTime.bind(this);

    this.generatePreviewInstances = this.generatePreviewInstances.bind(this);
    this.generatePreviewList = this.generatePreviewList.bind(this);

    this.createInstances = this.createInstances.bind(this);
  }

  public render() {
    return (
      <div>
         <Modal show={this.props.show} onHide={this.toggleModal} dialogClassName="modal-94">
          <Modal.Header closeButton={true}>
            <Modal.Title>Create Instances</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">

              <div className="col-lg-3 col-sm-12">
                <label>For Template</label>
                <select id="selectedTemplateId" className="form-control" value={this.state.selectedTemplateId} onChange={this.updateField}>
                  {this.props.templates.map((t) => {
                    return (
                      <option key={t.id} value={t.id}>{t.name}</option>
                    );
                  })}
                </select>
              </div>
              <div className="col-lg-3 col-sm-12">
                <label>Begins on</label>
                <DatePicker
                  date={this.state.startDate}
                  onDateSaved={this.updateStartDate}
                />
              </div>
              <div className="col-lg-3 col-sm-12">
                <label>At</label>
                <select id="startTime" className="form-control" value={this.state.startTime} onChange={this.updateField}>
                  {getTimePickerOptions()}
                </select>
              </div>
              <div className="col-lg-3 col-sm-12">
                <label>Length in minutes</label>
                <input type="text" id="numberOfMinutes" className="form-control" value={this.state.numberOfMinutes} onChange={this.updateField} />
              </div>
            </div>

            <div className="row" style={{marginTop: 20}}>
              <div className="col-lg-4 col-sm-12">
                <label>Multiple Per Day?</label>
                <select id="repeatMultiplePerDay" className="form-control" value={this.state.repeatMultiplePerDay} onChange={this.updateField}>
                  <option value="no">No, only one event per day in repeat period</option>
                  <option value="yes">Also create instance at these times each day:</option>
                </select>
              </div>
              <div className="col-lg-2 col-sm-12">
              {this.state.repeatMultiplePerDay === "yes" && (
                <button className="btn btn-block btn-primary" onClick={this.toggleShowAdditionalTimeModal}>Add Additional Time</button>
              )}
              </div>
              <div className="col-lg-6 col-sm-12">
                {this.state.repeatMultiplePerDay === "yes" && (
                  <div>
                    <div className="row">
                      <div className="col-12">
                        {this.state.additionalCreateTimes.length === 0 && (<strong>No additional times created</strong>)}
                      </div>
                    </div>
                    {this.state.additionalCreateTimes.map((t) => {
                      return (
                        <div className="row" key={t.startTime} style={{marginTop: 5}}>
                          <div className="col-lg-6 col-6">
                            {moment(t.startTime, "HH:mm").format("hh:mm A")}
                          </div>
                          <div className="col-lg-4 col-3">
                            {t.numberOfMinutes}
                          </div>
                          <div className="col-lg-2 col-3">
                            <span className="oi oi-x icon icon-danger" onClick={() => {this.removeAdditionalTime(t)}} title="Remove Time" />
                          </div>
                        </div>
                      )
                    })}

                  </div>
                )}
                
              </div>


            </div>
            <div className="row" style={{marginTop: 20}}>
              <div className="col-lg-4 col-sm-12">
                <label>Repeat throughtout the week?</label>
                <select id="repeatWeekly" className="form-control" value={this.state.repeatWeekly} onChange={this.updateField}>
                  <option value="no">No, Instance Should Only Happen On This Day</option>
                  <option value="yes">Also, repeat on the following days:</option>
                </select>
              </div>
                <div className="col-lg-8">

                {this.state.repeatWeekly === "yes" && (
                  <div>
                    <div className="row">
                      <div className="col-lg-1 col-4">
                        <label>Sunday</label>
                        <input type="checkbox" className="form-check" id="repeatSunday" checked={this.state.repeatSunday === "yes" ? true : false} onChange={this.updateCheckbox} />
                      </div>
                      <div className="col-lg-1 col-4">
                        <label>Monday</label>
                        <input type="checkbox" className="form-check" id="repeatMonday" checked={this.state.repeatMonday === "yes" ? true : false} onChange={this.updateCheckbox} />
                      </div>
                      <div className="col-lg-1 col-4">
                        <label>Tuesday</label>
                        <input type="checkbox" className="form-check" id="repeatTuesday" checked={this.state.repeatTuesday === "yes" ? true : false} onChange={this.updateCheckbox} />
                      </div>
                      <div className="col-lg-1 col-4">
                        <label>Wednesday</label>
                        <input type="checkbox" className="form-check" id="repeatWednesday" checked={this.state.repeatWednesday === "yes" ? true : false} onChange={this.updateCheckbox} />
                      </div>
                      <div className="col-lg-1 col-4">
                        <label>Thursday</label>
                        <input type="checkbox" className="form-check" id="repeatThursday" checked={this.state.repeatThursday === "yes" ? true : false} onChange={this.updateCheckbox} />
                      </div>
                      <div className="col-lg-1 col-4">
                        <label>Friday</label>
                        <input type="checkbox" className="form-check" id="repeatFriday" checked={this.state.repeatFriday === "yes" ? true : false} onChange={this.updateCheckbox} />
                      </div>
                      <div className="col-lg-1 col-4">
                        <label>Saturday</label>
                        <input type="checkbox" className="form-check" id="repeatSaturday" checked={this.state.repeatSaturday === "yes" ? true : false} onChange={this.updateCheckbox} />
                      </div>
                      <div className="col-lg-5 col-8">
                        <label>End Before</label>
                        <DatePicker
                          date={this.state.repeatEndDate}
                          onDateSaved={this.updateEndDate}
                        />
                      </div>
                    </div>
                  </div>
                )}
            </div>
          </div>
            <div className="row" style={{marginTop: 20}}>
              <div className="col-lg-4 col-sm-12">
                <label>When should these be available?</label>
                <select id="releaseOnType" className="form-control" value={this.state.releaseOnType} onChange={this.updateField}>
                  <option value="immediately">Release Immediately</option>
                  <option value="absolute">Make Available On:</option>
                </select>
              </div>
              <div className="col-lg-4 col-sm-12" style={{marginTop: 31}}>
              {this.state.releaseOnType === "absolute" && (
                <DatePicker
                  date={this.state.releaseOnDate}
                  onDateSaved={this.updateReleaseDate}
                />
              )}
              </div>
              <div className="col-lg-4 col-sm-12">
              {this.state.releaseOnType === "absolute" && (
                <div>
                  <label>At</label>
                  <select id="releaseOnTime" className="form-control" value={this.state.releaseOnTime} onChange={this.updateField}>
                    {getTimePickerOptions()}
                  </select>
                </div>
              )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-block btn-primary" onClick={this.generatePreviewInstances} >Preview What Will Be Created</button>
            <button className="btn btn-block btn-default" onClick={this.toggleModal}>Nevermind</button>
          </Modal.Footer>
        </Modal>

        <Modal show={this.state.showAddStartTimeModal} onHide={this.toggleShowAdditionalTimeModal}>
          <Modal.Header closeButton={true}>
            <Modal.Title>Add Additional Times</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group">
              <label>Additional Time Slots</label>
              <select id="additionalStartTime" className="form-control" value={this.state.additionalStartTime} onChange={this.updateField}>
                {getTimePickerOptions()}
              </select>
            </div>
            <div className="form-group">
              <label>Length in Minutes</label>
              <input type="text" id="additionalNumberOfMinutes" className="form-control" value={this.state.additionalNumberOfMinutes} onChange={this.updateField} />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-block btn-primary" onClick={this.addNewAdditionalTime}>Add New Time</button>
            <button className="btn btn-block btn-default" onClick={this.toggleShowAdditionalTimeModal}>Nevermind</button>
          </Modal.Footer>
        </Modal>

        <Modal show={this.state.showPreviewModal} onHide={this.togglePreviewModal} background="static">
          <Modal.Header closeButton={true}>
            <Modal.Title>Previewing Instances</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <span>Creating <strong>{this.state.allCreateTimes.length}</strong> instances.</span>
            {this.generatePreviewList()}
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-block btn-primary" onClick={this.createInstances}>Yes, Create {this.state.allCreateTimes.length} Instances!</button>
            <button className="btn btn-block btn-default" onClick={this.togglePreviewModal}>Nevermind</button>
          </Modal.Footer>
        </Modal>


      </div>
    );
  }

  private updateField(e: any){
    const ns = this.state;
    const id = e.target.id;
    let val = e.target.value;
    ns[id] = val;
    this.setState(ns);
  }

  private updateCheckbox(e: any){
    const val = e.target.value === "on" ? "yes" : "no";
    const id = e.target.id;
    const ns = this.state;
    ns[id] = val;
    this.setState(ns)
  }

  private updateStartDate(newDate: moment.Moment){
    const repeatEndDate = newDate.clone().add(2, "weeks");
    this.setState({ startDate: newDate, repeatEndDate});
  }

  private updateEndDate(newDate: moment.Moment){
    this.setState({ repeatEndDate: newDate});
  }

  private updateReleaseDate(newDate: moment.Moment){
    this.setState({ releaseOnDate: newDate});
  }

  private toggleModal(){
    this.props.hide();
  }

  private toggleShowAdditionalTimeModal(){
    // set the selected time to the start time plus 10 minutes
    const newAdditionalTime = moment(this.state.startTime, "HH:mm").clone().add(10, "minutes").format("HH:mm");
    this.setState({
      showAddStartTimeModal: !this.state.showAddStartTimeModal, 
      additionalNumberOfMinutes: this.state.numberOfMinutes, 
      additionalStartTime: newAdditionalTime
    });
  }

  private togglePreviewModal(){
    this.setState({showPreviewModal: !this.state.showPreviewModal});
  }

  private addNewAdditionalTime(){
    const times = this.state.additionalCreateTimes;

    // if it's already the start time, let's just leave now
    if(this.state.additionalStartTime === this.state.startTime){
      error("That time is already the start time!");
      return this.setState({
        showAddStartTimeModal: false,
      });
    }

    // I am going to uniqify these for now until I hear a reason not to
    for(const ct of times){
      if(ct.startTime === this.state.additionalStartTime){
        return this.setState({
          showAddStartTimeModal: false,
        });
      }
    }
    
    times.push({startTime: this.state.additionalStartTime, numberOfMinutes: this.state.additionalNumberOfMinutes});
    times.sort((a, b) => {
      return a.startTime > b.startTime ? 1 : -1;
    })
    const newAdditionalTime = moment(times[times.length -1].startTime, "HH:mm").add(30, "minutes").format("HH:mm");
    this.setState({
      additionalCreateTimes: times,
      additionalStartTime: newAdditionalTime,
      additionalNumberOfMinutes: this.state.numberOfMinutes,
      showAddStartTimeModal: false,
    });
  }

  private removeAdditionalTime(time: ICreateTime){
    const times: ICreateTime[] = [];
    for(const t of this.state.additionalCreateTimes){
      if(t.startTime !== time.startTime){
        times.push(t);
      }
    }
    this.setState({additionalCreateTimes: times});
  }

  private generatePreviewInstances(){
    this.setState({ loadingWhileCalculating: true}, () => {
      // first, we need to make a copy of the start date
      // since it is not immutable
      const startDateCopy = this.state.startDate.clone();
      const additionalInstances: ICreateTime[] = [];
      const dateFormat = "YYYY-MM-DDTHH:mm:00Z";

      // the plan:
      // we start with the start date
      // then we loop over each day until we get to the end date
      // for each day, we loop over the additional times as well as the main time
      // we create instances and shove them in the array
      //

      // today first!

      let initialHour: any = "";
      let initialMinutes: any = "";
      const sp = this.state.startTime.split(":");
      initialHour = parseInt(sp[0], 10);
      initialMinutes = parseInt(sp[1], 10);
      additionalInstances.push({
        startTime: startDateCopy.hour(initialHour).minute(initialMinutes).format(dateFormat),
        numberOfMinutes: this.state.numberOfMinutes 
      });

      // first, handle the start day instances
      if(this.state.repeatMultiplePerDay === "yes"){
        for(const ai of this.state.additionalCreateTimes){
          const startDate = this.state.startDate.clone();
          const sp = ai.startTime.split(":");
          const st = {
            startTime: startDate.hour(parseInt(sp[0], 10)).minute(parseInt(sp[1], 10)).format(dateFormat),
            numberOfMinutes: ai.numberOfMinutes 
          };
          additionalInstances.push(st);
        }
      }
      
      // now weekly repeats
      const repeatStartDate = this.state.startDate.clone();
      if(this.state.repeatWeekly === "yes"){
        const currentDate = repeatStartDate.add(1, "day");
        const endDate = this.state.repeatEndDate;
        while(currentDate.isBefore(endDate)){
          // check if the day is a repeat day
          const day = currentDate.weekday();
          let create = false;
          if(day === 0 && this.state.repeatSunday === "yes"){
            create = true;
          } else if(day === 1 && this.state.repeatMonday === "yes"){
            create = true;
          } else if(day === 2 && this.state.repeatTuesday === "yes"){
            create = true;
          } else if(day === 3 && this.state.repeatWednesday === "yes"){
            create = true;
          } else if(day === 4 && this.state.repeatThursday === "yes"){
            create = true;
          } else if(day === 5 && this.state.repeatFriday === "yes"){
            create = true;
          } else if(day === 6 && this.state.repeatSaturday === "yes"){
            create = true;
          }

          if(create){
            // first, the current fields
            const st = {
              startTime: currentDate.hour(initialHour).minute(initialMinutes).format(dateFormat),
              numberOfMinutes: this.state.numberOfMinutes,
            };
            additionalInstances.push(st);
            // we need to loop and handle
            for(const ai of this.state.additionalCreateTimes){
              const sp = ai.startTime.split(":");
              const st = {
                startTime: currentDate.hour(parseInt(sp[0], 10)).minute(parseInt(sp[1], 10)).format(dateFormat),
                numberOfMinutes: ai.numberOfMinutes 
              };
              additionalInstances.push(st);
            }
          }
          currentDate.add(1, "day");
        }
      }
      this.setState({allCreateTimes: additionalInstances, loading: false, loadingWhileCalculating: false, showPreviewModal: true});
    });
    
  }

  private generatePreviewList(){
    const items: any = [];
    const maxToShow = 15;
    const max = this.state.allCreateTimes.length > maxToShow ? maxToShow : this.state.allCreateTimes.length;
    // TODO: add show all button
    for(let i = 0; i < max; i++){
      items.push(
        <div className="row" key={i}>
          <div className="col-md-8">
            {moment(this.state.allCreateTimes[i].startTime).format("MM/DD/YY hh:mm A")}
          </div>
          <div className="col-md-4">
            {this.state.allCreateTimes[i].numberOfMinutes} minutes
          </div>
        </div>
      );
    }
    if(this.state.allCreateTimes.length > maxToShow){
      items.push(
        <div className="row" key={-1}>
          <div className="col-md-12">
            Plus <strong>{this.state.allCreateTimes.length - maxToShow}</strong> more!
          </div>
        </div>
      )
    }
    return items;
  }


  private createInstances(){
    const dateFormat = "YYYY-MM-DDTHH:mm:00Z";
    this.setState({showPreviewModal: false, loading: true, loadingWhileCalculating: true}, async () => {
      try{
        const first = this.state.allCreateTimes[0];
        const data: any = {
          startTime: moment(first.startTime).utc().format(dateFormat),
          numberOfMinutes: parseInt(this.state.numberOfMinutes, 10),
          createTimes: []
        };
        // the 0th element is the original
        for(let i = 1; i < this.state.allCreateTimes.length; i++){
          data.createTimes.push({
            startTime: moment(this.state.allCreateTimes[i].startTime).utc().format(dateFormat),
            numberOfMinutes: parseInt(this.state.allCreateTimes[i].numberOfMinutes),
          })
        }
        data.releaseOnType = this.state.releaseOnType;
        if(data.releaseOnType === "absolute"){
          const parts = this.state.releaseOnTime.split(":");
          const hour = parseInt(parts[0], 10);
          const minute = parseInt(parts[1], 10);
          data.releaseOnDate = this.state.releaseOnDate.hour(hour).minute(minute).utc().format(dateFormat);
        }
        console.log(data);
        // fun fact: sometimes the react rendered mounts this before the props are in place, so if they
        // don't change the instance, it will still be 0; instead, make it the first
        const templateId = this.state.selectedTemplateId === 0 ? this.props.templates[0].id : this.state.selectedTemplateId;
        // send it up?
        await EventsAPI.createEventTemplateInstances(this.props.organization.id, templateId, data);
        // theoretically, we should clear back to initial state?
        this.setState({...initialState, additionalCreateTimes: [], allCreateTimes: [],}, () => {
          this.props.onInstancesCreated();
        })
      }catch(err){
        if(err.code && err.code === 402){
          return error("Creating those instances would go over the maximum number of allowed instances. Please upgrade your subscription or contact support.", "Quota Exceeded", {timeOut: 7000});
        }
        error("Could not create those instances.");
      }
    });
  }
}

// TODO: extract this and add the ability to filter
const getTimePickerOptions = () => {
  // const now = moment().hour(0).minute(0);
  // const end = moment().hour(23).minute(59);
  // const options: any = [];
  // let string = '[';
  // while(now.isBefore(end)){
  //   options.push(
  //     <option key={now.format("HH:mm")} value={now.format("HH:mm")}>{now.format("hh:mm A")}</option>
  //   );
  //   string += `(<option key="${now.format("HH:mm")}" value="${now.format("HH:mm")}">${now.format("hh:mm A")}</option>),`;
  //   now.add(10, "minutes");
  // }
  // string += ']';
  // console.log(string);
  // return options;

  return [(<option key="00:00" value="00:00">12:00 AM</option>),(<option key="00:10" value="00:10">12:10 AM</option>),(<option key="00:20" value="00:20">12:20 AM</option>),(<option key="00:30" value="00:30">12:30 AM</option>),(<option key="00:40" value="00:40">12:40 AM</option>),(<option key="00:50" value="00:50">12:50 AM</option>),(<option key="01:00" value="01:00">01:00 AM</option>),(<option key="01:10" value="01:10">01:10 AM</option>),(<option key="01:20" value="01:20">01:20 AM</option>),(<option key="01:30" value="01:30">01:30 AM</option>),(<option key="01:40" value="01:40">01:40 AM</option>),(<option key="01:50" value="01:50">01:50 AM</option>),(<option key="02:00" value="02:00">02:00 AM</option>),(<option key="02:10" value="02:10">02:10 AM</option>),(<option key="02:20" value="02:20">02:20 AM</option>),(<option key="02:30" value="02:30">02:30 AM</option>),(<option key="02:40" value="02:40">02:40 AM</option>),(<option key="02:50" value="02:50">02:50 AM</option>),(<option key="03:00" value="03:00">03:00 AM</option>),(<option key="03:10" value="03:10">03:10 AM</option>),(<option key="03:20" value="03:20">03:20 AM</option>),(<option key="03:30" value="03:30">03:30 AM</option>),(<option key="03:40" value="03:40">03:40 AM</option>),(<option key="03:50" value="03:50">03:50 AM</option>),(<option key="04:00" value="04:00">04:00 AM</option>),(<option key="04:10" value="04:10">04:10 AM</option>),(<option key="04:20" value="04:20">04:20 AM</option>),(<option key="04:30" value="04:30">04:30 AM</option>),(<option key="04:40" value="04:40">04:40 AM</option>),(<option key="04:50" value="04:50">04:50 AM</option>),(<option key="05:00" value="05:00">05:00 AM</option>),(<option key="05:10" value="05:10">05:10 AM</option>),(<option key="05:20" value="05:20">05:20 AM</option>),(<option key="05:30" value="05:30">05:30 AM</option>),(<option key="05:40" value="05:40">05:40 AM</option>),(<option key="05:50" value="05:50">05:50 AM</option>),(<option key="06:00" value="06:00">06:00 AM</option>),(<option key="06:10" value="06:10">06:10 AM</option>),(<option key="06:20" value="06:20">06:20 AM</option>),(<option key="06:30" value="06:30">06:30 AM</option>),(<option key="06:40" value="06:40">06:40 AM</option>),(<option key="06:50" value="06:50">06:50 AM</option>),(<option key="07:00" value="07:00">07:00 AM</option>),(<option key="07:10" value="07:10">07:10 AM</option>),(<option key="07:20" value="07:20">07:20 AM</option>),(<option key="07:30" value="07:30">07:30 AM</option>),(<option key="07:40" value="07:40">07:40 AM</option>),(<option key="07:50" value="07:50">07:50 AM</option>),(<option key="08:00" value="08:00">08:00 AM</option>),(<option key="08:10" value="08:10">08:10 AM</option>),(<option key="08:20" value="08:20">08:20 AM</option>),(<option key="08:30" value="08:30">08:30 AM</option>),(<option key="08:40" value="08:40">08:40 AM</option>),(<option key="08:50" value="08:50">08:50 AM</option>),(<option key="09:00" value="09:00">09:00 AM</option>),(<option key="09:10" value="09:10">09:10 AM</option>),(<option key="09:20" value="09:20">09:20 AM</option>),(<option key="09:30" value="09:30">09:30 AM</option>),(<option key="09:40" value="09:40">09:40 AM</option>),(<option key="09:50" value="09:50">09:50 AM</option>),(<option key="10:00" value="10:00">10:00 AM</option>),(<option key="10:10" value="10:10">10:10 AM</option>),(<option key="10:20" value="10:20">10:20 AM</option>),(<option key="10:30" value="10:30">10:30 AM</option>),(<option key="10:40" value="10:40">10:40 AM</option>),(<option key="10:50" value="10:50">10:50 AM</option>),(<option key="11:00" value="11:00">11:00 AM</option>),(<option key="11:10" value="11:10">11:10 AM</option>),(<option key="11:20" value="11:20">11:20 AM</option>),(<option key="11:30" value="11:30">11:30 AM</option>),(<option key="11:40" value="11:40">11:40 AM</option>),(<option key="11:50" value="11:50">11:50 AM</option>),(<option key="12:00" value="12:00">12:00 PM</option>),(<option key="12:10" value="12:10">12:10 PM</option>),(<option key="12:20" value="12:20">12:20 PM</option>),(<option key="12:30" value="12:30">12:30 PM</option>),(<option key="12:40" value="12:40">12:40 PM</option>),(<option key="12:50" value="12:50">12:50 PM</option>),(<option key="13:00" value="13:00">01:00 PM</option>),(<option key="13:10" value="13:10">01:10 PM</option>),(<option key="13:20" value="13:20">01:20 PM</option>),(<option key="13:30" value="13:30">01:30 PM</option>),(<option key="13:40" value="13:40">01:40 PM</option>),(<option key="13:50" value="13:50">01:50 PM</option>),(<option key="14:00" value="14:00">02:00 PM</option>),(<option key="14:10" value="14:10">02:10 PM</option>),(<option key="14:20" value="14:20">02:20 PM</option>),(<option key="14:30" value="14:30">02:30 PM</option>),(<option key="14:40" value="14:40">02:40 PM</option>),(<option key="14:50" value="14:50">02:50 PM</option>),(<option key="15:00" value="15:00">03:00 PM</option>),(<option key="15:10" value="15:10">03:10 PM</option>),(<option key="15:20" value="15:20">03:20 PM</option>),(<option key="15:30" value="15:30">03:30 PM</option>),(<option key="15:40" value="15:40">03:40 PM</option>),(<option key="15:50" value="15:50">03:50 PM</option>),(<option key="16:00" value="16:00">04:00 PM</option>),(<option key="16:10" value="16:10">04:10 PM</option>),(<option key="16:20" value="16:20">04:20 PM</option>),(<option key="16:30" value="16:30">04:30 PM</option>),(<option key="16:40" value="16:40">04:40 PM</option>),(<option key="16:50" value="16:50">04:50 PM</option>),(<option key="17:00" value="17:00">05:00 PM</option>),(<option key="17:10" value="17:10">05:10 PM</option>),(<option key="17:20" value="17:20">05:20 PM</option>),(<option key="17:30" value="17:30">05:30 PM</option>),(<option key="17:40" value="17:40">05:40 PM</option>),(<option key="17:50" value="17:50">05:50 PM</option>),(<option key="18:00" value="18:00">06:00 PM</option>),(<option key="18:10" value="18:10">06:10 PM</option>),(<option key="18:20" value="18:20">06:20 PM</option>),(<option key="18:30" value="18:30">06:30 PM</option>),(<option key="18:40" value="18:40">06:40 PM</option>),(<option key="18:50" value="18:50">06:50 PM</option>),(<option key="19:00" value="19:00">07:00 PM</option>),(<option key="19:10" value="19:10">07:10 PM</option>),(<option key="19:20" value="19:20">07:20 PM</option>),(<option key="19:30" value="19:30">07:30 PM</option>),(<option key="19:40" value="19:40">07:40 PM</option>),(<option key="19:50" value="19:50">07:50 PM</option>),(<option key="20:00" value="20:00">08:00 PM</option>),(<option key="20:10" value="20:10">08:10 PM</option>),(<option key="20:20" value="20:20">08:20 PM</option>),(<option key="20:30" value="20:30">08:30 PM</option>),(<option key="20:40" value="20:40">08:40 PM</option>),(<option key="20:50" value="20:50">08:50 PM</option>),(<option key="21:00" value="21:00">09:00 PM</option>),(<option key="21:10" value="21:10">09:10 PM</option>),(<option key="21:20" value="21:20">09:20 PM</option>),(<option key="21:30" value="21:30">09:30 PM</option>),(<option key="21:40" value="21:40">09:40 PM</option>),(<option key="21:50" value="21:50">09:50 PM</option>),(<option key="22:00" value="22:00">10:00 PM</option>),(<option key="22:10" value="22:10">10:10 PM</option>),(<option key="22:20" value="22:20">10:20 PM</option>),(<option key="22:30" value="22:30">10:30 PM</option>),(<option key="22:40" value="22:40">10:40 PM</option>),(<option key="22:50" value="22:50">10:50 PM</option>),(<option key="23:00" value="23:00">11:00 PM</option>),(<option key="23:10" value="23:10">11:10 PM</option>),(<option key="23:20" value="23:20">11:20 PM</option>),(<option key="23:30" value="23:30">11:30 PM</option>),(<option key="23:40" value="23:40">11:40 PM</option>),(<option key="23:50" value="23:50">11:50 PM</option>)];
}